import classNames from 'classnames';
import * as React from 'react';
import Linkify from 'react-linkify';

import RichViewer from '../../common/editors/RichViewer';
import StringUtils from '../../utils/StringUtils';

import css from './DescriptionPanel.module.scss';

interface Props {
  className?: string;
  description: string;
  jsonDescription?: string;
}

const MerchantCourseDetailsDescription = ({
  className,
  description,
  jsonDescription,
}: Props) => {
  const classes = classNames(css.DescriptionPanel, className);

  return (
    <div className={classes}>
      {jsonDescription ? (
        <RichViewer value={jsonDescription} />
      ) : (
        description && (
          <Linkify>{StringUtils.simpleFormat(description)}</Linkify>
        )
      )}
    </div>
  );
};

export default MerchantCourseDetailsDescription;
